var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"aliCodeValidate"}},[_c('button',{ref:"fmAliCode",staticStyle:{"display":"none"},attrs:{"id":"fmAliCode"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }